document.addEventListener('DOMContentLoaded', function () {
	if (!window.agendUpbeatContactLookupForms) {
		return;
	}

	const formData = window.agendUpbeatContactLookupForms[0];
	const $form = document.querySelector(formData.form_selector);

	if (!$form.classList.contains('js-ahri-update-registration')) {
		return;
	}

	// Registration type field is the first select field in the form.
	const $registrationTypeField = $form.querySelector('select');
	if (!$registrationTypeField) {
		console.warn('Could not locate the registration type field...');
		return;
	}

	// Quick and dirty way to handle registration type change in Gravity Forms now that both types have name fields.
	$registrationTypeField.addEventListener('change', event => {
		const isSelfRegistration = $registrationTypeField.value === 'self-registration';
		const $clearButton = document.querySelector('.agend-upbeat-contact-lookup__action--clear');
		if (isSelfRegistration) {
			return;
		}

		// Clear any prefilled data in the form when the registration type changes.
		setTimeout(function () {
			$clearButton.click();
		}, 50);
	});
});
